import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { firebaseConnect } from 'react-redux-firebase'
import { Link } from 'react-router-dom'

const _ = require('lodash')

class SignupContainer extends React.Component {
  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
        createHref: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }

  constructor() {
    super()
    this.state = {
      phoneNumber: '',
      customerName: '',
      email: '',
      showStepOne: true,
      showStepTwo: false,
      showStepThree: false,
      verificationCode: null,
      error: null,
      isLoadingGif: true,
    }

    if (window.user && window.user.phoneNumber) {
      this.state.showStepOne = false
      this.state.showStepTwo = false
      this.state.showStepThree = false
    }
  }

  componentDidMount() {
    window.recaptchaVerifier = new this.props.firebase.auth.RecaptchaVerifier('signup-button', { size: 'invisible' })
  }

  componentWillReceiveProps(nextProps) {
    // if (this.props.drawingSquares !== nextProps.drawingSquares) {
    //   this.setState({ isLoadingGif: true });
    //   generateGIF(window.firebase, nextProps.drawing, nextProps.drawingId, nextProps.lastDrawingSquareId);
    // } else if (this.props.drawing !== nextProps.drawing) {
    //   if (nextProps.drawing && nextProps.drawing.gifUrl) {
    //     this.setState({ isLoadingGif: false });
    //   }
    // }
  }

  updateNameInputValue(evt) {
    this.setState({ customerName: evt.target.value })
  }

  updateEmailInputValue(evt) {
    this.setState({ email: evt.target.value })
  }

  updatePhoneInputValue(evt) {
    this.setState({ phoneNumber: evt.target.value })
  }

  updateVerificationCodeInputValue(evt) {
    this.setState({ verificationCode: evt.target.value })
  }

  parsePhoneNumber() {
    return this.state.phoneNumber
      .replace('+', '')
      .replace('-', '')
      .replace('(', '')
      .replace(')', '')
  }

  signUpEmail = (event) => {
    event.preventDefault()
    const { email, customerName } = this.state
    const { drawingId, firebase } = this.props

    const newKey = firebase
      .database()
      .ref()
      .child(`userEmails/${drawingId}`)
      .push().key

    firebase
      .database()
      .ref(`/userEmails/${drawingId}/${newKey}`)
      .set(
        {
          email,
          name: customerName,
        },
        (error) => {
          if (error) {
            // The write failed...
            this.setState({
              error: `There was an error saving your email address: ${error}`,
            })
          } else {
            const doneUrl = `/drawings/${this.props.match.params.id}/${this.props.match.params.index}/done`
            this.context.router.history.push(doneUrl)
          }
        },
      )
  }

  signUpVerifyPhoneNumber() {
    let phoneNumber = this.parsePhoneNumber()
    phoneNumber = `+${phoneNumber.startsWith(1) ? '' : 1}${phoneNumber}`

    const self = this
    this.props.firebase
      .auth()
      .signInWithPhoneNumber(phoneNumber, window.recaptchaVerifier)
      .then((confirmationResult) => {
        console.log(confirmationResult)
        window.confirmationResult = confirmationResult
        self.setState({
          showStepOne: false,
          showStepTwo: true,
          error: null,
        })
        return Promise.resolve(confirmationResult)
      })
      .then((confirmationResult) => {
        console.log(confirmationResult)
      })
      .catch((e) => {
        self.setState({
          error: 'There was an error texting your phone number. Be sure it is in this format: 9781234567',
        })
      })
  }

  renderStepOne() {
    const doneUrl = `/drawings/${this.props.match.params.id}/${this.props.match.params.index}/done`
    const { drawing } = this.props
    let imgPlaceHolder = null
    let drawingGifUrl = null

    if (this.state.isLoadingGif) {
      // imgPlaceHolder = <div>Gif loading . . .</div>;
      imgPlaceHolder = <div />
    } else {
      drawingGifUrl = drawing.gifUrl
    }
    return (
      <div>
        {/* <h2>Sign up and we'll text you a timelapse GIF of this Piccle</h2> */}
        <h2>Get a timelapse GIF of this Piccle once it's done</h2>
        {/* <img style={{width:'65%'}} src="https://app.piccles.com/img/pizza.gif"/><br/> */}
        {!imgPlaceHolder ? <img style={{ width: '65%' }} src={drawingGifUrl} alt="Gif" /> : imgPlaceHolder}
        {/* <br />
        <br /> */}
        {this.state.error && <span className="error">{this.state.error}</span>}
        <form onSubmit={this.signUpEmail}>
          <input
            placeholder="What is your name?"
            type="text"
            className="form-field"
            maxLength="30"
            onChange={(evt) => this.updateNameInputValue(evt)}
          />
          <input
            placeholder="What is your email address?"
            type="email"
            className="form-field"
            maxLength="50"
            required
            onChange={(evt) => this.updateEmailInputValue(evt)}
          />
          <button id="signup-button" type="submit">
            Email me the GIF
            <br />
          </button>
        </form>

        <Link
          to={doneUrl}
          style={{
            fontWeight: 'bold',
            color: '#CCC',
            fontSize: '18px',
            marginTop: '14px',
            textDecoration: 'none',
            display: 'block',
          }}
        >
          SKIP
        </Link>
      </div>
    )
  }

  renderStepTwo() {
    return (
      <div>
        <h2>Enter the verification code we just texted you</h2>
        {this.state.error && <span className="error">{this.state.error}</span>}
        <input
          placeholder="Verification Code"
          type="tel"
          className="form-field"
          maxLength="10"
          onChange={(evt) => this.updateVerificationCodeInputValue(evt)}
        />
        <button
          id="signup-button"
          type="submit"
          disabled={this.parsePhoneNumber().length < 6}
          onClick={this.verifyCode.bind(this)}
        >
          Verify
        </button>
      </div>
    )
  }

  renderStepThree() {
    return (
      <div>
        <h2>Thanks for signing up! We'll text you a GIF once this Piccle is completed.</h2>
      </div>
    )
  }

  verifyCode() {
    const self = this
    const credential = this.props.firebase.auth.PhoneAuthProvider.credential(
      window.confirmationResult.verificationId,
      this.state.verificationCode,
    )

    const anonymousUserId = this.props.firebase.auth().currentUser.uid
    console.log('ANONYMOUS USER ID:', anonymousUserId)
    this.props.firebase
      .auth()
      .currentUser.linkWithCredential(credential)
      .then(
        function(user) {
          console.log('SIGNED UP SUCCESSFULLY>>>>>>>>>>>>>>>')
          window.user = user
          // self.setState({
          //   error:null,
          //   showStepOne: false,
          //   showStepTwo: false,
          //   showStepThree: true
          // })
          return Promise.resolve(user)
        },
        function(error) {
          console.log('Error upgrading anonymous account', error)
          if (error.code === 'auth/credential-already-in-use') {
            return self.props.firebase.auth().signInWithCredential(credential)
          }
        },
      )
      .then((user) => {
        window.user = user
        const phoneNumberUpdate = this.props.firebase
          .database()
          .ref(`/userProfiles/${user.uid}`)
          .update({
            phoneNumber: user.phoneNumber,
          })
        const anonymousUserIdUpdate = this.props.firebase
          .database()
          .ref(`/userProfiles/${user.uid}/associatedAnonymousUserIds`)
          .push(anonymousUserId)
        const promises = [phoneNumberUpdate, anonymousUserIdUpdate]

        const doneUrl = `/drawings/${this.props.match.params.id}/${this.props.match.params.index}/done`
        Promise.all(promises).then(() => {
          this.context.router.history.push(doneUrl)
        })
      })
  }

  render() {
    return (
      <div className="container">
        {this.state.showStepOne && this.renderStepOne()}
        {this.state.showStepTwo && this.renderStepTwo()}
        {this.state.showStepThree && this.renderStepThree()}
      </div>
    )
  }
}

export default compose(
  firebaseConnect((props) => {
    // Set listeners based on props (prop is route parameter from react-router in this case)
    return [
      `drawings/${props.match.params.id}`,
      { path: '/drawingSquares', queryParams: ['orderByChild=drawing', `equalTo=${props.match.params.id}`] },
    ]
  }),
  connect((state, props, dispatch) => {
    return {
      drawingId: props.match.params.id,
      lastDrawingSquareId: props.match.params.drawingSquare,
      drawing: _.get(state.firebase.data, `drawings.${props.match.params.id}`),
      drawingSquares: state.firebase.ordered.drawingSquares,
    }
  }),
)(SignupContainer)



// WEBPACK FOOTER //
// ./src/containers/signupContainer.js